import { productDetails } from "../constants";

const getProductDetailsText = ({ productType }) => productDetails[productType];

export default getProductDetailsText;
